import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, CreditCard, ShieldCheck, HelpCircle, ArrowRight, MapPin, Video, Mail, Phone } from 'lucide-react';
export function FeesPage() {
  return <>
      {/* Hero */}
      <section className="bg-olive py-16 md:py-20" data-id="element-842">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-843">
          <div className="text-center max-w-3xl mx-auto" data-id="element-844">
            <span className="text-gold font-bold uppercase tracking-widest text-xs mb-4 block" data-id="element-845">
              FEES & POLICIES
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-846">
              Transparent <span className="italic text-cream" data-id="element-847">Pricing</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg font-medium" data-id="element-848">
              Clear, straightforward fees with flexible payment options. No
              surprises.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="py-16 lg:py-20 bg-cream" data-id="element-849">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-850">
          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-851">
            <div data-id="element-852">
              <div className="bg-white rounded-2xl p-8 border border-charcoal/10 h-full flex flex-col" data-id="element-853">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-854">
                  Individual Session
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-855">
                  <span className="text-4xl font-bold text-olive" data-id="element-856">$150</span>
                  <span className="text-charcoal/50 font-medium" data-id="element-857">
                    / 50 minutes
                  </span>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow" data-id="element-858">
                  One-on-one therapy sessions focused on your personal goals,
                  healing, and growth.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-859">
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-860">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-861" />
                    <span data-id="element-862">In-person or Telehealth</span>
                  </li>
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-863">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-864" />
                    <span data-id="element-865">Personalized treatment plan</span>
                  </li>
                </ul>
                <Link to="/booking" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-866">
                  Book Individual
                </Link>
              </div>
            </div>

            <div data-id="element-867">
              <div className="bg-white rounded-2xl p-8 border-2 border-olive shadow-soft-lg relative h-full flex flex-col" data-id="element-868">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-olive text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide uppercase whitespace-nowrap" data-id="element-869">
                  Most Popular
                </div>
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2 mt-2" data-id="element-870">
                  Couples Session
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-871">
                  <span className="text-4xl font-bold text-olive" data-id="element-872">$180</span>
                  <span className="text-charcoal/50 font-medium" data-id="element-873">
                    / 60 minutes
                  </span>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow" data-id="element-874">
                  Joint sessions to improve communication, resolve conflicts,
                  and rebuild your connection.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-875">
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-876">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-877" />
                    <span data-id="element-878">In-person or Telehealth</span>
                  </li>
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-879">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-880" />
                    <span data-id="element-881">Conflict resolution tools</span>
                  </li>
                </ul>
                <Link to="/booking" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-882">
                  Book Couples
                </Link>
              </div>
            </div>

            <div data-id="element-883">
              <div className="bg-white rounded-2xl p-8 border border-charcoal/10 h-full flex flex-col" data-id="element-884">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-885">
                  Family Session
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-886">
                  <span className="text-4xl font-bold text-olive" data-id="element-887">$180</span>
                  <span className="text-charcoal/50 font-medium" data-id="element-888">
                    / 60 minutes
                  </span>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow" data-id="element-889">
                  Therapeutic support for families navigating conflict and life
                  transitions together.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-890">
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-891">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-892" />
                    <span data-id="element-893">In-person or Telehealth</span>
                  </li>
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-894">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-895" />
                    <span data-id="element-896">All family configurations</span>
                  </li>
                </ul>
                <Link to="/booking" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-897">
                  Book Family
                </Link>
              </div>
            </div>
          </div>

          {/* Free Consultation */}
          <div data-id="element-898">
            <div className="bg-olive/10 rounded-2xl p-8 text-center border border-olive/15 max-w-3xl mx-auto" data-id="element-899">
              <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-900">
                Free 15-Minute Consultation
              </h3>
              <p className="text-charcoal/70 text-base font-medium mb-6 max-w-lg mx-auto" data-id="element-901">
                Not sure where to start? Book a free phone consultation to
                discuss your needs and see if we're a good fit. No commitment
                required.
              </p>
              <Link to="/booking" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-8 py-3.5 rounded-full font-bold text-base transition-all min-h-[48px]" data-id="element-902">
                Book Free Consultation
                <ArrowRight size={16} className="ml-2" data-id="element-903" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Insurance & Payment */}
      <section className="py-16 lg:py-20 bg-white" data-id="element-904">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-905">
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-906">
            <div data-id="element-907">
              <div className="bg-cream rounded-2xl p-8 h-full" data-id="element-908">
                <div className="flex items-center gap-3 mb-4" data-id="element-909">
                  <div className="w-12 h-12 rounded-xl bg-olive/10 flex items-center justify-center text-olive" data-id="element-910">
                    <ShieldCheck size={24} data-id="element-911" />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-charcoal" data-id="element-912">
                    Insurance Coverage
                  </h3>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 leading-relaxed" data-id="element-913">
                  Services may be covered by your health insurance or employee
                  benefit plan. I provide detailed receipts for reimbursement
                  through your insurance provider.
                </p>

                <div className="space-y-4" data-id="element-914">
                  <div className="bg-gold/10 border border-gold/20 rounded-xl p-4" data-id="element-915">
                    <p className="text-charcoal font-bold text-sm leading-relaxed" data-id="element-916">
                      Employee Assistance Programs (EAPs) and Health Spending
                      Accounts also cover therapy provided by a Registered
                      Social Worker.
                    </p>
                  </div>
                  <div className="bg-olive/10 border border-olive/20 rounded-xl p-4" data-id="element-917">
                    <p className="text-charcoal font-bold text-sm leading-relaxed" data-id="element-918">
                      Psychotherapy and Social Work services are considered
                      eligible health expenses and may be claimed on your
                      personal income tax return.
                    </p>
                  </div>
                </div>

                <p className="text-charcoal/60 text-sm font-medium mt-6" data-id="element-919">
                  Common providers that may cover services include: Sun Life,
                  Manulife, Great-West Life, Blue Cross, Green Shield, and many
                  employer benefit plans.
                </p>
              </div>
            </div>

            <div data-id="element-920">
              <div className="bg-cream rounded-2xl p-8 h-full" data-id="element-921">
                <div className="flex items-center gap-3 mb-4" data-id="element-922">
                  <div className="w-12 h-12 rounded-xl bg-olive/10 flex items-center justify-center text-olive" data-id="element-923">
                    <CreditCard size={24} data-id="element-924" />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-charcoal" data-id="element-925">
                    Payment & Policies
                  </h3>
                </div>
                <ul className="space-y-3 text-base text-charcoal/80 font-medium mb-6" data-id="element-926">
                  <li className="flex justify-between border-b border-charcoal/10 pb-3" data-id="element-927">
                    <span data-id="element-928">Accepted Methods</span>
                    <span className="font-bold text-charcoal" data-id="element-929">
                      Credit Card, e-Transfer
                    </span>
                  </li>
                  <li className="flex justify-between border-b border-charcoal/10 pb-3" data-id="element-930">
                    <span data-id="element-931">Payment Due</span>
                    <span className="font-bold text-charcoal" data-id="element-932">
                      At time of session
                    </span>
                  </li>
                  <li className="flex justify-between border-b border-charcoal/10 pb-3" data-id="element-933">
                    <span data-id="element-934">Cancellation Notice</span>
                    <span className="font-bold text-charcoal" data-id="element-935">48 hours</span>
                  </li>
                  <li className="flex justify-between" data-id="element-936">
                    <span data-id="element-937">Late Cancellation Fee</span>
                    <span className="font-bold text-charcoal" data-id="element-938">
                      Full session rate
                    </span>
                  </li>
                </ul>

                <div className="bg-white/50 rounded-xl p-4 mb-4 border border-charcoal/5" data-id="element-939">
                  <p className="text-sm text-charcoal/80 font-medium leading-relaxed" data-id="element-940">
                    You can cancel or reschedule appointments via the Jane app
                    or send an email to{' '}
                    <a href="mailto:esther@esthermensahcounselling.com" className="font-bold hover:text-olive transition-colors" data-id="element-941">
                      esther@esthermensahcounselling.com
                    </a>
                  </p>
                </div>

                <div className="bg-olive/10 p-4 rounded-xl" data-id="element-942">
                  <h4 className="font-bold text-olive mb-1 text-sm uppercase tracking-wide" data-id="element-943">
                    Sliding Scale Available
                  </h4>
                  <p className="text-sm text-charcoal/70 font-medium leading-relaxed" data-id="element-944">
                    Limited spots available for those experiencing financial
                    hardship. Please inquire during your consultation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Appointment Options */}
      <section className="py-16 lg:py-20 bg-olive/5 border-t border-charcoal/5" data-id="element-945">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-946">
          <div className="text-center mb-10" data-id="element-947">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-948">
              Appointment Options
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-949">
            <div className="bg-white rounded-2xl p-8 border border-charcoal/5 shadow-sm flex flex-col items-center text-center" data-id="element-950">
              <div className="w-16 h-16 rounded-full bg-olive/10 flex items-center justify-center text-olive mb-6" data-id="element-951">
                <MapPin size={28} data-id="element-952" />
              </div>
              <h3 className="font-heading text-xl font-bold text-charcoal mb-4" data-id="element-953">
                In-Person Sessions
              </h3>
              <p className="text-charcoal/80 font-medium mb-8" data-id="element-954">
                In-person sessions are offered at{' '}
                <strong data-id="element-955">370 Queens Ave, London, Ontario.</strong>
              </p>
              <Link to="/contact" className="mt-auto inline-flex items-center justify-center bg-white border-2 border-olive text-olive hover:bg-olive hover:text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px]" data-id="element-956">
                View Location Details
              </Link>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-charcoal/5 shadow-sm flex flex-col items-center text-center" data-id="element-957">
              <div className="w-16 h-16 rounded-full bg-olive/10 flex items-center justify-center text-olive mb-6" data-id="element-958">
                <Video size={28} data-id="element-959" />
              </div>
              <h3 className="font-heading text-xl font-bold text-charcoal mb-4" data-id="element-960">
                Virtual / Online Sessions
              </h3>
              <p className="text-charcoal/80 font-medium mb-8" data-id="element-961">
                Virtual/Online sessions are offered across Ontario using a
                secure PHIPA-compliant platform.
              </p>
              <Link to="/booking" className="mt-auto inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px]" data-id="element-962">
                Book an Appointment
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 lg:py-20 bg-cream" data-id="element-963">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-964">
          <div className="text-center mb-10" data-id="element-965">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-966">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-4 mb-16" data-id="element-967">
            <div data-id="element-968">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-969">
                <div className="flex items-start gap-3" data-id="element-970">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-971" />
                  <div data-id="element-972">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-973">
                      Do I need a referral?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-974">
                      No referral is needed. You can book directly through our
                      website or by calling the office.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-975">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-976">
                <div className="flex items-start gap-3" data-id="element-977">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-978" />
                  <div data-id="element-979">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-980">
                      How long does therapy take?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-981">
                      The duration varies based on your needs and goals. Some
                      clients see improvement in 6-8 sessions, while others
                      benefit from longer-term support. We'll discuss this
                      during your consultation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-982">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-983">
                <div className="flex items-start gap-3" data-id="element-984">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-985" />
                  <div data-id="element-986">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-987">
                      Is virtual therapy as effective as in-person?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-988">
                      Research shows that virtual therapy is equally effective
                      for most concerns. It also offers greater flexibility and
                      accessibility, especially for those across Ontario.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-989">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-990">
                <div className="flex items-start gap-3" data-id="element-991">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-992" />
                  <div data-id="element-993">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-994">
                      What if I need to cancel?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-995">
                      Please provide at least 48 hours notice for cancellations.
                      Late cancellations or no-shows will be charged the full
                      session rate.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-996">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-997">
                <div className="flex items-start gap-3" data-id="element-998">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-999" />
                  <div data-id="element-1000">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-1001">
                      Do you offer a sliding scale?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-1002">
                      Yes, I offer a limited number of sliding scale spots for
                      clients experiencing financial hardship. Please ask about
                      availability during your free consultation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-1003">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-1004">
                <div className="flex items-start gap-3" data-id="element-1005">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-1006" />
                  <div data-id="element-1007">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-1008">
                      What insurance do you accept?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-1009">
                      I provide detailed receipts that you can submit to your
                      insurance provider for reimbursement. Please check with
                      your provider to ensure they cover "Registered
                      Psychotherapists" or "Registered Social Workers".
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center bg-white rounded-2xl p-8 border border-charcoal/5 shadow-sm" data-id="element-1010">
            <h3 className="font-heading text-xl font-bold text-charcoal mb-4" data-id="element-1011">
              For more information or inquiries:
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-1012">
              <a href="mailto:esther@esthermensahcounselling.com" className="flex items-center gap-2 text-olive hover:text-gold font-bold transition-colors" data-id="element-1013">
                <Mail size={20} data-id="element-1014" />
                esther@esthermensahcounselling.com
              </a>
              <a href="tel:5489000692" className="flex items-center gap-2 text-olive hover:text-gold font-bold transition-colors" data-id="element-1015">
                <Phone size={20} data-id="element-1016" />
                548-900-0692
              </a>
            </div>
          </div>
        </div>
      </section>
    </>;
}